import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './datepickers.css';
import 'react-datepicker/dist/react-datepicker.css';

class Datepickers extends Component {

  constructor(props) {
    super(props);
    const dateFrom = moment(this.props.dateFrom, 'YYYY-MM-DD');
    const dateTo = moment(this.props.dateTo, 'YYYY-MM-DD');
    this.state = {
      dateFrom: dateFrom,
      dateTo: dateTo,
    };
    this.onChangeDateFrom = this.onChangeDateFrom.bind(this);
    this.onChangeDateTo = this.onChangeDateTo.bind(this);
  }

  onChangeDateFrom(date: Moment) {
    if (date.isSameOrBefore(this.state.dateTo))
      this.setState({ dateFrom: date });
  }

  onChangeDateTo(date: Moment) {
    if (date.isSameOrAfter(this.state.dateFrom))
      this.setState({ dateTo: date });
  }

  render() {
    if (!this.props.custom) return null;
    const dpFrom = (
      <span className="datepicker-input">
        <label>From</label> {this.state.dateFrom.format('YYYY/MM/DD')}
      </span>
    );
    const dpTo = (
      <span className="datepicker-input">
        <label>To</label> {this.state.dateTo.format('YYYY/MM/DD')}
      </span>
    );
    let yesterday = moment().startOf('day');
    const changed = !(this.state.dateFrom.isSame(this.props.dateFrom) && this.state.dateTo.isSame(this.props.dateTo));
    const dateFromStr = this.state.dateFrom.format('YYYY-MM-DD');
    const dateToStr = this.state.dateTo.format('YYYY-MM-DD');
    const applyElement = changed ?
      (
        <li>
          <Link to={`${ this.props.location.pathname }#date-from=${ dateFromStr }&date-to=${ dateToStr }`} onClick={e => this.props.parametersChanged(e)} className="button">Go</Link>
        </li>
      ) :
      null;
    yesterday.subtract(1, 'days');
    return (
      <section className="Datepickers">
        <ul className="dp">
          <li>
            <DatePicker
              customInput={dpFrom}
              selected={this.state.dateFrom}
              selectsStart
              startDate={this.state.dateFrom}
              endDate={this.state.dateTo}
              maxDate={yesterday}
              dateFormat='YYYY/MM/DD'
              onChange={this.onChangeDateFrom}
            />
          </li>
          <li>
            <DatePicker
              customInput={dpTo}
              selected={this.state.dateTo}
              selectsEnd
              startDate={this.state.dateFrom}
              endDate={this.state.dateTo}
              maxDate={yesterday}
              dateFormat='YYYY/MM/DD'
              onChange={this.onChangeDateTo}
            />
          </li>
          {applyElement}
        </ul>
      </section>
    );
  }

};

export default Datepickers;



// WEBPACK FOOTER //
// ./src/app/stats/container/dates/datepickers.js